module.exports = __webpack_public_path__ + "static/media/transformcity_cover.5c388aba.png";